/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Input} from '@angular/core';


let /** @type {?} */ nextUniqueId = 0;
/**
 * Single error message to be shown underneath the form field.
 */
export class MdError {
   id: string = `mat-error-${nextUniqueId++}`;
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-error, mat-error',
  host: {
    'class': 'mat-error',
    'role': 'alert',
    '[attr.id]': 'id',
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
};
}

function MdError_tsickle_Closure_declarations() {
/** @type {?} */
MdError.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdError.ctorParameters;
/** @type {?} */
MdError.propDecorators;
/** @type {?} */
MdError.prototype.id;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
